<template>
    <section class="bonusomat-raffle">
        <BonusomatRaffleCountersSection
            :has-raffle-data-loading-failed="
                isDefaultDrawDataLoaded && !defaultDrawData && isAllwynDrawDataLoaded && !allwynDrawData
            "
            :show-default-counters="defaultDrawData && isDefaultDrawDataLoaded"
            :total-win="defaultDrawData?.totalWin ?? 0"
            :raffle-remaining-seconds="raffleRemainingSeconds"
            :show-allwyn-counters="allwynDrawData && isAllwynDrawDataLoaded"
            :allwyn-name="allwynDrawData?.name"
            :allwyn-remaining-seconds="allwynDrawRemainingSeconds"
            :show-tickets-counters="true"
            :raffle-tickets-count="defaultDrawData?.playerTickets ?? 0"
            :allwyn-tickets-count="allwynDrawData?.playerTickets ?? 0"
            :isWidget="false"
            @open-win-table-modal="openWinTableModal"
        />

        <RafflePrizesModal
            v-if="isDefaultDrawDataLoaded && isAllwynDrawDataLoaded"
            v-model="isModalOpen"
            :default-draw-win-table="defaultDrawData?.winTable"
            :allwyn-draw="allwynDrawData"
            btn-right-icon="check"
        />
    </section>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";
import BonusomatRaffleCountersSection from "./bonusomat-raffle-counters-section.vue";
import useBonusomatAllwynDrawCountdown from "../../composables/use-bonusomat-allwyn-countdown";
import useBonusomatData from "../../composables/use-bonusomat-data";
import useBonusomatDrawCountdown from "../../composables/use-bonusomat-raffle-countdown";
import RafflePrizesModal from "../shared/raffle-prizes-modal.vue";

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { bonusomatPlayerData, remainingSpinsCount } = bonusomatPlayerStatus;

const { defaultDrawData, isDefaultDrawDataLoaded, allwynDrawData, isAllwynDrawDataLoaded } = useBonusomatData();

const { raffleRemainingSeconds } = useBonusomatDrawCountdown();
const { allwynDrawRemainingSeconds } = useBonusomatAllwynDrawCountdown();

const isModalOpen = ref(false);

const openWinTableModal = async () => {
    isModalOpen.value = true;

    BonusomatDatalayer.pushMoreInfoClick(
        "Ceny v losovačce",
        bonusomatPlayerData.value.points,
        remainingSpinsCount.value
    );
};
</script>
